import { InputHTMLAttributes, forwardRef } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  icon?: React.ReactNode
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-semibold text-brown-800 mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-brown-600/50">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`w-full px-4 py-3 rounded-lg border-2 bg-white text-brown-900 placeholder-brown-600/50 ${
              icon ? 'pl-12' : ''
            } ${
              error
                ? 'border-error-500 focus:border-error-500 focus:ring-error-500'
                : 'border-cream-200 focus:border-primary-500 focus:ring-primary-500'
            } focus:ring-2 focus:ring-opacity-50 outline-none transition-colors min-h-11 ${className}`}
            {...props}
          />
        </div>
        {error && <p className="mt-1.5 text-sm text-error-600">{error}</p>}
      </div>
    )
  }
)

Input.displayName = 'Input'
